export default "/images/dc66a745f24acace3a10f031ca589794.jpg";